var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-sr-area"},[_c('div',{staticClass:"content-inner inner-media-width yd-display-flex yd-justifyContent-s"},[_c('transition',{attrs:{"name":"fade-left-right","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),_c('right-navbar')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77a201e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutSr/index.vue
// module id = null
// module chunks = 